export default function offerFormHandler() {
	const offerToggleButtons = document.querySelectorAll('.js-offer-toggle');
	const offerForm = document.querySelector('.js-offer');
	const offerCloseButton = document.querySelector('.js-offer-close');
	const body = document.body;

	if (offerForm) {
		offerToggleButtons.forEach(button => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				offerForm.classList.add('is-visible');
				body.classList.add('has-offer-open');
			});
		});

		if (offerCloseButton) {
			offerCloseButton.addEventListener('click', (event) => {
				event.preventDefault();
				offerForm.classList.remove('is-visible');
				body.classList.remove('has-offer-open');
			});
		}

		document.addEventListener('click', (event) => {
			if (!offerForm.contains(event.target) && !event.target.closest('.js-offer-toggle')) {
				offerForm.classList.remove('is-visible');
				body.classList.remove('has-offer-open');
			}
		});
	}
}